import { GAME_VARIABLES } from "../../../constants";

export class Chunk3 {
  constructor(scene: Phaser.Scene) {
    const sprite1 = scene.add.sprite(
      0,
      GAME_VARIABLES.IS_RESTART ? 0 : 100,
      "atlas",
      "background_chunk3/high_clouds"
    );

    const sprite2 = scene.add.sprite(
      0,
      GAME_VARIABLES.IS_RESTART ? 0 : -10,
      "atlas",
      "background_chunk3/city"
    );

    const sprite3 = scene.add.sprite(
      0,
      0,
      "atlas",
      "background_chunk3/gradient"
    );
    const sprite4 = scene.add.sprite(
      0,
      0,
      "atlas",
      "background_chunk3/radial_gradient_light_blue"
    );
    sprite4.setAlpha(0.15);

    sprite4.setBlendMode(Phaser.BlendModes.SCREEN);

    if (!GAME_VARIABLES.IS_RESTART) {
      scene.add.tween({
        targets: sprite1,
        y: `-=100`,
        duration: 3000,
        ease: "Expo.easeIn",
      });
      scene.add.tween({
        targets: sprite2,
        y: `+=10`,
        duration: 3000,
        ease: "Expo.easeOut",
      });
    }

    sprite1.setDepth(-2);
    sprite2.setDepth(-1.9);
    sprite3.setDepth(-2.1);
    sprite4.setDepth(-1.85);
    sprite3.setActive(false);
    sprite1.setActive(false);
    sprite2.setActive(false);
    sprite4.setActive(false);
  }
}
